import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

type IssuerDiffersAlertProps = {
  title: string;
  /** Already filled with the entered and discovered issuer. */
  body: string;
  confirmLabel: string;
  confirmed: boolean;
  onConfirmedChange: (confirmed: boolean) => void;
  disabled?: boolean;
};

/** QL-619 — the identity provider reports another issuer than entered; the admin must confirm it. */
export function IssuerDiffersAlert({
  title,
  body,
  confirmLabel,
  confirmed,
  onConfirmedChange,
  disabled,
}: IssuerDiffersAlertProps) {
  return (
    <Alert variant="warning">
      <AlertTriangle />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription className="space-y-3 text-muted-foreground">
        <p className="[overflow-wrap:anywhere]">{body}</p>
        <div className="flex items-start gap-2">
          <Checkbox
            id="confirmDiscoveredIssuer"
            checked={confirmed}
            onCheckedChange={(checked) => onConfirmedChange(checked === true)}
            disabled={disabled}
          />
          <Label
            htmlFor="confirmDiscoveredIssuer"
            className="font-medium text-foreground [overflow-wrap:anywhere]"
          >
            {confirmLabel}
          </Label>
        </div>
      </AlertDescription>
    </Alert>
  );
}
